import { Link,graphql, useStaticQuery } from "gatsby"
import React from "react"

const Header = (props) => {
  const data = useStaticQuery(
    graphql`
    {
      allWpMenu {
        edges {
          node {
            slug
            name
            id
            menuItems {
              nodes {
                label
				        title
                url
                order
                parentId
                childItems {
                  nodes {
                    label
					          title
                    url
					target
                    description
                  }
                }
              }
            }
          }
        }
      }
    }
    `
  );

  var menus= data.allWpMenu.edges;
  var menu_principal= [];
  for(var i in menus){
    if(menus[i].node.name==="menu_principal_" + props.langPage){
        menu_principal=menus[i].node.menuItems.nodes;
        break;
    }
  }

  return (
 <header className={"header-home header-white " + "cabecera-"+props.clase_pagina}>
    <div className="container">
	  <div className="row">
	  <div className="logo col-6 col-md-2"><Link to={`/${props.langPage}`} title="Homepage Billage"><img src="/images/logo-billage-color.svg" alt="Logo billage" with="130" height="45"/></Link></div>
	  <nav className="menu-main col-6  col-md-10">
	  <button id="pull" className="hamburger-menu" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-icon"></span>
              </button>

    <ul className="menuItems">
    {menu_principal.map(( node ) =>{
      const hasChilds=node.childItems.nodes.length!==0 ? true : false;

      // const final_url= node.url.substring(0,node.url.length-1);
      if(node.parentId==null){
        return (<li className={ (hasChilds ? "dropdown dropdown-submenu has-sub " :"") + "hidden-sm hidden-xs"}>
          <div className="int-item">
              <Link to={node.url.charAt(node.url.length-1)=="/" ? node.url.substring(0,node.url.length-1) : node.url} className={hasChilds ? "dropbtn dropdown-toggle" :"dropbtn"}>
                <p>{node.label}</p>
              </Link>
              {hasChilds
               ?
                 <div className={"dropdown-content " + node.title}>
                   <ul className="">
                   {node.childItems.nodes.map(( node ) => {
                     // const final_url= node.url.substring(0,node.url.length-1);
		     var url= node.url.replace("/category","");
                     return  <li className="">
                      <Link to={url.charAt(node.url.length-1)=="/" ? url.substring(0,node.url.length-1) : url} className={props.idPage!==undefined && node.id==props.idPage ? "active" : ""} title={node.label} target={node.target} rel={node.target=='_blank'? 'noopener noreferrer' : null}>
                        <div className="menu-descripcion">
                          <div className="menu-descripcion-titulo">{node.label}</div>
                          <div className="menu-descripcion-texto"><p>{node.title}</p></div>
                        </div>
                      </Link>
                    </li>;
                    }
                    )}

                  </ul>
                 </div>
               :
                 null
              }
          </div>
          </li>);
        }

    return null;
    }

  )}
<li className="boto menu-option-login">
							<Link to="https://app.getbillage.com/saas" rel="alternate" hrefLang="es" className="buttonLogin" >Iniciar sesión</Link>
						</li>
<li className="boto menu-option-pruebalo">
	                        <Link to="https://app.getbillage.com/saas/register/view-register" className="boton boton-arrow"><span>Empieza gratis</span></Link>
	                    </li>
   </ul>
</nav>
    </div>
</div>
  </header>);
}

export default Header
